/* esm.sh - applesauce-core@5.2.0/operations */
export * from "/*applesauce-core@5.2.0/esnext/operations.mjs";
